import { render } from "./alert-box.vue?vue&type=template&id=39d2de76&scoped=true&ts=true"
import script from "./alert-box.vue?vue&type=script&lang=ts"
export * from "./alert-box.vue?vue&type=script&lang=ts"

import "./alert-box.vue?vue&type=style&index=0&id=39d2de76&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d2de76"]])

export default __exports__